import React from 'react'
import Marketplace from "./Marketplace"

const CreateNFT = () => {
  return (
    <div>
      <Marketplace/>
    </div>
  )
}

export default CreateNFT
